export interface IAccountLogin {
    access_token: string;
    expires_in: number;
    token_type: string;
}

export class AccountLogin {
    public access_token: string;
    public expires_in: number;
    public token_type: string;

    constructor();
    constructor(obj: IAccountLogin);
    constructor(obj?: any) {
      this.access_token = obj && obj.access_token || "";
      this.expires_in = obj && obj.expires_in || 0;
      this.token_type = obj && obj.token_type || "";
    }
}
